import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { GATEWAY_URL } from '../constants';
import { InboxDto, ReferenceDto } from '../model';

@Injectable()
export class LookupApiService {
  private readonly http = inject(HttpClient);
  private readonly gatewayUrl = inject(GATEWAY_URL);

  public getAllInboxes(): Observable<InboxDto[]> {
    return this.http.get<InboxDto[]>(`${this.getBaseUrl()}/inbox/getAll`);
  }

  // We have reference endpoints since OData filters on application key for the value while modals need the id
  public getFaxFolderReferences(inboxApplicationKey: string): Observable<ReferenceDto[]> {
    return this.http.get<ReferenceDto[]>(`${this.getBaseUrl()}/faxFolder?inboxApplicationKey=${inboxApplicationKey}`);
  }

  public getStatusReferences(): Observable<ReferenceDto[]> {
    return this.http.get<ReferenceDto[]>(`${this.getBaseUrl()}/status`);
  }

  public getRequestTypeReferences(tenantLobProductId: string): Observable<ReferenceDto[]> {
    return this.http.get<ReferenceDto[]>(`${this.getBaseUrl()}/requestType?tenantLobProductId=${tenantLobProductId}`);
  }

  public getArchivedReasonReferences(): Observable<ReferenceDto[]> {
    return this.http.get<ReferenceDto[]>(`${this.getBaseUrl()}/archivedReason`);
  }

  public getAssignedUsersFilter(inboxId: string): Observable<SelectItem[]> {
    return this.http.get<SelectItem[]>(`${this.getBaseUrl()}/assignedUsers?inboxId=${inboxId}`);
  }

  private getBaseUrl(): string {
    return `${this.gatewayUrl}/api/IFA/Lookup`;
  }
}
